const compiler = require('vue-template-compiler')

export function register({ template, name, group }) {
  if (!template || !name || !group)
    throw new Error('Invalid params')

  template = template.split('<br>').join('')

  const compiledComponent = compiler.compileToFunctions(template)
  window.AngularEcommerce.web.templates = window.AngularEcommerce.web.templates || {}
  window.AngularEcommerce.web.templates[group] = window.AngularEcommerce.web.templates[group] || {}
  window.AngularEcommerce.web.templates[group][name] = compiledComponent
}
